// @flow
/** @jsx jsx */

import { isEmptyString } from '@zapier/common-utils';
import { jsx } from '@emotion/core';

import SearchBox from 'app/common/components/SearchBox';
import ZapMoverZapsList from 'app/zap-mover/components/FilterableZapsList/ZapMoverZapsList';

import type {
  FolderType,
  OnChooseFolderType,
  OnChooseZapType,
} from 'app/zap-mover/types';

type Props = {
  folders: Array<FolderType>,
  fromAccountId: number,
  query: string,
  onChooseFolder: OnChooseFolderType,
  onChooseZap: OnChooseZapType,
  onFilterZaps: string => void,
  isSingleSelect?: boolean,
};

const wrapperCss = {
  '& > :first-of-type': {
    marginBottom: -1,
  },
};

const FilterableZapsList = (props: Props) => {
  return (
    <div css={wrapperCss}>
      <SearchBox
        kind="flat-bottom"
        onChangeValue={props.onFilterZaps}
        onReset={() => props.onFilterZaps('')}
        value={props.query}
      />
      <ZapMoverZapsList
        folders={props.folders}
        isFiltered={!isEmptyString(props.query)}
        isSingleSelect={props.isSingleSelect}
        onChooseFolder={props.onChooseFolder}
        onChooseZap={props.onChooseZap}
      />
    </div>
  );
};

export default FilterableZapsList;
